import { render, staticRenderFns } from "./basicInformation.vue?vue&type=template&id=a3fbfe2e&scoped=true"
import script from "./basicInformation.vue?vue&type=script&lang=js"
export * from "./basicInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3fbfe2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a3fbfe2e')) {
      api.createRecord('a3fbfe2e', component.options)
    } else {
      api.reload('a3fbfe2e', component.options)
    }
    module.hot.accept("./basicInformation.vue?vue&type=template&id=a3fbfe2e&scoped=true", function () {
      api.rerender('a3fbfe2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mechanism/components/myDealChild/child/orderDetailChild/basicInformation.vue"
export default component.exports